module.exports = __webpack_public_path__ + "static/media/easymarketcover.3c566a5d.PNG";